// ============================================
// 2. hotels.js - 酒店管理（可独立管理60+个）
// ============================================

// ============================================
// Canada
// ============================================
export const hotels = {
  "distillery-lofts": {
    id: "distillery-lofts",
    cityId: "toronto",
    name: "The Distillery Lofts Hotel",
    description: "Luxury boutique hotel in Victorian-era historic district with modern amenities and charm."
  },
  "prince-of-wales": {
    id: "prince-of-wales",
    cityId: "niagaraFalls",
    name: "Prince of Wales Hotel",
    description: "Historic luxury hotel overlooking the Niagara River with elegant Victorian architecture."
  },
  "fairmont-chateau-laurier": {
    id: "fairmont-chateau-laurier",
    cityId: "ottawa",
    name: "Fairmont Château Laurier",
    description: "Grand historic hotel in downtown near all major attractions."
  },
  "ritz-carlton-montreal": {
    id: "ritz-carlton-montreal",
    cityId: "montreal",
    name: "Ritz-Carlton Montreal",
    description: "Prestigious luxury hotel with sophisticated design and world-class service."
  },
  "chateau-frontenac": {
    id: "chateau-frontenac",
    cityId: "quebecCity",
    name: "Château Frontenac",
    description: "Iconic luxury castle hotel overlooking the St. Lawrence River with timeless elegance."
  },

  // ============================================
  // Italy
  // ============================================

  "grand-hotel-tremezzo": {
    id: "grand-hotel-tremezzo",
    cityId: "milan",
    name: "Grand Hotel Tremezzo",
    description: "An iconic art nouveau masterpiece offering unparalleled views of Bellagio and the lake."
  },
  "cristallo": {
    id: "cristallo",
    cityId: "dolomites",
    name: "Cristallo, a Luxury Collection Resort",
    description: "Historic mountain resort offering refined elegance in the heart of the Dolomites."
  },
  "belmond-hotel-cipriani": {
    id: "belmond-hotel-cipriani",
    cityId: "venice",
    name: "Belmond Hotel Cipriani",
    description: "Legendary luxury on Giudecca Island with spectacular views of the Venetian lagoon."
  },
  "four-seasons-firenze": {
    id: "four-seasons-firenze",
    cityId: "florence",
    name: "Four Seasons Hotel Firenze",
    description: "A Renaissance palace featuring an enchanting private botanical garden."
  },
  "le-sirenuse": {
    id: "le-sirenuse",
    cityId: "amalfiCoast",
    name: "Le Sirenuse",
    description: "A luxury boutique hotel offering the most famous views of Positano's colorful houses."
  },
  "hotel-hassler-roma": {
    id: "hotel-hassler-roma",
    cityId: "rome",
    name: "Hotel Hassler Roma",
    description: "Set at the top of the Spanish Steps, one of the city's most prestigious landmarks."
  }
};